import React, { useEffect, useState } from "react";
import { styled } from "@mui/material";
import Container from "../../../components/PageContainer";
import InnerContainer from "../../../components/PageInnerContainer";
import PageTitle from "../../../components/PageTitle";
import PageSubTitle from "../../../components/PageSubTitle";
import Button from "../../../components/Button";
import ContentBox, { ContentHeader } from "../../../components/ContentBox";
import { StepComponentProps } from "./index";
import useGetOnboarding from "../../../hooks/queries/admin/useGetOnboarding";
import useSaveOnboarding from "../../../hooks/mutations/admin/useSaveOnboarding";
import Switch from "../../../components/Switch";

const AdoptionItem = styled(`div`)`
  display: flex;
  font-size: 16px;
  font-weight: 500;
  align-items: center;
`;

const AdoptionItemContent = styled(`p`)`
  margin: 10px 0px;
`;

const defaultItemValues = {
  adoption_send_emails: true,
  adoption_send_texts: true,
  adoption_send_flyers: true,
  adoption_custom_images: false,
  adoption_include_spanish: false,
  adoption_tifin_responsible: true,
};

const AdoptionPlan = ({ nextStep }: StepComponentProps) => {
  const [items, setItems] = useState(defaultItemValues);

  const { data } = useGetOnboarding();
  const { mutate: saveOnboarding } = useSaveOnboarding({
    onSuccessHandler: nextStep,
  });

  useEffect(() => {
    if (data) {
      const program = data.program;
      setItems({
        adoption_send_emails: program.adoption_send_emails
          ? program.adoption_send_emails
          : defaultItemValues.adoption_send_emails,
        adoption_send_texts: program.adoption_send_texts
          ? program.adoption_send_texts
          : defaultItemValues.adoption_send_texts,
        adoption_send_flyers: program.adoption_send_flyers
          ? program.adoption_send_flyers
          : defaultItemValues.adoption_send_flyers,
        adoption_custom_images: program.adoption_custom_images
          ? program.adoption_custom_images
          : defaultItemValues.adoption_custom_images,
        adoption_include_spanish: program.adoption_include_spanish
          ? program.adoption_include_spanish
          : defaultItemValues.adoption_include_spanish,
        adoption_tifin_responsible: program.adoption_tifin_responsible
          ? program.adoption_tifin_responsible
          : defaultItemValues.adoption_tifin_responsible,
      });
    }
  }, [data]);

  const setValue = (key: string, value: boolean) => {
    setItems({ ...items, [key]: value });
  };

  const handleContinue = () => {
    saveOnboarding({ programItems: { ...items } });
  };

  if (data) {
    return (
      <Container>
        <PageTitle>
          We will help you create awareness and invite employees to participate.{" "}
        </PageTitle>
        <PageSubTitle>
          To get the highest level of adoption, this is our recommended plan.
          You can customize to fit your needs.
        </PageSubTitle>
        <InnerContainer>
          <ContentBox>
            <ContentHeader>Selected Employee Adoption Plan</ContentHeader>
            <AdoptionItem>
              <Switch
                checked={items["adoption_send_emails"]}
                onClick={(e) =>
                  setValue(
                    "adoption_send_emails",
                    !items["adoption_send_emails"]
                  )
                }
              />
              <AdoptionItemContent>Send email(s)</AdoptionItemContent>
            </AdoptionItem>
            <AdoptionItem>
              <Switch
                checked={items["adoption_send_texts"]}
                onClick={(e) =>
                  setValue("adoption_send_texts", !items["adoption_send_texts"])
                }
              />
              <AdoptionItemContent>Send texts(s)</AdoptionItemContent>
            </AdoptionItem>
            <AdoptionItem>
              <Switch
                checked={items["adoption_send_flyers"]}
                onClick={(e) =>
                  setValue(
                    "adoption_send_flyers",
                    !items["adoption_send_flyers"]
                  )
                }
              />
              <AdoptionItemContent>In-person flyers(s)</AdoptionItemContent>
            </AdoptionItem>
            <AdoptionItem>
              <Switch
                checked={items["adoption_custom_images"]}
                onClick={(e) =>
                  setValue(
                    "adoption_custom_images",
                    !items["adoption_custom_images"]
                  )
                }
              />
              <AdoptionItemContent>
                Images for newsletter or social
              </AdoptionItemContent>
            </AdoptionItem>
            <AdoptionItem>
              <Switch
                checked={items["adoption_include_spanish"]}
                onClick={(e) =>
                  setValue(
                    "adoption_include_spanish",
                    !items["adoption_include_spanish"]
                  )
                }
              />
              <AdoptionItemContent>
                Include Spanish translations
              </AdoptionItemContent>
            </AdoptionItem>
            <AdoptionItem>
              <Switch
                checked={items["adoption_tifin_responsible"]}
                onClick={(e) =>
                  setValue(
                    "adoption_tifin_responsible",
                    !items["adoption_tifin_responsible"]
                  )
                }
              />
              <AdoptionItemContent>
                TIFIN is responsible for sending communications
              </AdoptionItemContent>
            </AdoptionItem>
          </ContentBox>
          <p style={{ textAlign: "center" }}>
            Our team will followup with the selected marketing collateral for
            your review.
          </p>
          <Button onClick={handleContinue}>Continue</Button>
        </InnerContainer>
      </Container>
    );
  }
  return null;
};

export default AdoptionPlan;
